import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import Link from "@mui/material/Link";

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
  progressBarText:
    "Add 2 games for 10% off tickets, add 3 games for 20% off, 4 games for 30% off & the chance to watch fireworks on the field, or 5 games for 40% off & an exclusive giveaway opportunity on Sept 6th!",
  progressBarAditionalText: " to continue.",
};

export const InlandEmpire66ersLink = () => (
  <Link
    href={"https://mlb.tickets.com/?agency=ISSM_MYTIXX&orgid=57610#/auth/login"}
    target={"_blank"}
    sx={{
      color: "primary.main",
      textDecoration: "none",
      fontWeight: 500,
    }}
  >
    MyTickets
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your Inland Empire 66ers account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <InlandEmpire66ersLink /> account
        within 24 hours of purchase. Reach out to Live Fan Support or Inland
        Empire 66ers Box Office at{" "}
        <Link
          href="tel:9098889922"
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          (909) 888-9922
        </Link>
        .
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Inland Empire 66ers Family Pack work?",
    description:
      "The Inland Empire 66ers Family Pack allows fans to select any seat to select games hosted by the Inland Empire 66ers. The more games you select, the greater the discount on your tickets! Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "Yes, you can choose from all currently available Box Seat inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Inland Empire 66ers{" "}
        <InlandEmpire66ersLink /> Account.
      </>
    ),
  },
  {
    title:
      "How do I find out more information about the fireworks on the field or Sept 6th giveaway?",
    description:
      "The box office will be in touch if you are eligible for the fireworks on the field or Sept 6th guaranteed giveaway after you complete your purchase.",
  },
];
